import {
	SURVEY_GET_PERIODS_STARTED,
	SURVEY_GET_PERIODS_SUCCESS,
	SURVEY_GET_PERIODS_FAILED,
	SURVEY_DATA_RECEIVED,
	SURVEY_DATA_UDPATE,
	SEND_DATA_ERROR,
	INFO_MESSAGE,
	CLEAR_INFOR_AND_ERRO_MESSAGES,
	SURVEY_YEAR_CHANGED, NO_DATA_ACTION
} from "./DynamicSurveyActions";

import { schemaJsonMetamodel, possibleFieldTypes } from "./DynamicSurveyActions";


const recalculateReferences = (allFieldsObjectMetamodel, changedPropertyName, valuesFromState) => {

	if(allFieldsObjectMetamodel[changedPropertyName].lookup) {
		if(allFieldsObjectMetamodel[changedPropertyName].lookup.target) {
			let field = allFieldsObjectMetamodel[allFieldsObjectMetamodel[changedPropertyName].lookup.target];
			let lookupAllValues = schemaJsonMetamodel.lookup[allFieldsObjectMetamodel[changedPropertyName].lookup.values];
			if(lookupAllValues) {
				let lookupValues = lookupAllValues.filter(x => x.value === valuesFromState[changedPropertyName]);
				if(lookupValues && lookupValues.length > 0) {
					valuesFromState[field.name] = {lang: lookupValues[0].lang};
				} else {
					valuesFromState[field.name] = "";
				}
			}
		}
	}

	if(!allFieldsObjectMetamodel[changedPropertyName].references || allFieldsObjectMetamodel[changedPropertyName].references.length === 0) {
		return valuesFromState;
	}

	allFieldsObjectMetamodel[changedPropertyName].references.forEach(referencedField => {
		let calculatedField = allFieldsObjectMetamodel[referencedField];
		if (calculatedField.calculation.type === "sum") {
			let calculatedValue = calculatedField.calculation.fields.reduce(
				(accumulator, currentValue) => {
					return (
						accumulator +
						(valuesFromState[currentValue] ? Number(valuesFromState[currentValue]) : 0)
					);
				},
				0
			);
			valuesFromState[calculatedField.name] = calculatedValue;
			valuesFromState = recalculateReferences(allFieldsObjectMetamodel, calculatedField.name, valuesFromState);
		}

		if (calculatedField.calculation.type === "formula") {
			let calculatedValueFormula = calculateFormula(calculatedField.calculation.formula, valuesFromState);
			if(calculatedValueFormula !== null) {
				valuesFromState[calculatedField.name] = calculatedValueFormula;
				valuesFromState = recalculateReferences(allFieldsObjectMetamodel, calculatedField.name, valuesFromState);
			} else {
				delete valuesFromState[calculatedField.name];
			}
		}

		if (calculatedField.calculation.type === "substring") { 
			let start = Number(calculatedField.calculation.start);
			let end = Number(calculatedField.calculation.end);
			let source = calculatedField.calculation.source;
			let subStringValue = (valuesFromState[source] + "").substring(start - 1, end);
			valuesFromState[calculatedField.name] = subStringValue;
			valuesFromState = recalculateReferences(allFieldsObjectMetamodel, calculatedField.name, valuesFromState);
		}

	});

	return valuesFromState;

}


export const calculateFormula = (formulaInput, valuesFromState) => {
	let formula = [...formulaInput].reverse();
	let operandsStack = [];
	let error = null;

	while ((formula.length > 0) && (error == null)){
		
		let element = formula.pop();

		switch (element.type){
			case 'operand':
				if(!valuesFromState[element.field]) {
					operandsStack.push(0);
				}
				else {
				   operandsStack.push(valuesFromState[element.field]);
				/*} else {
					error = "ERROR UNDEFINED VALUE: " + element.field;
					console.error(error); */            
				}
				break;
			case 'operator':
				let val = operateFormula(operandsStack, element.operator);
				if(val === null) {
					error = "ERROR IN CALCUALTION DIVISION BY ZERO";
					// console.error(error);
				} else {
					operandsStack.push(val);
				}
				break;
			case 'value':
				operandsStack.push(element.value);
				break;
			default:				
		}
	}
		
	if (error == null){
		return operandsStack.pop();
	}
	

	return null;

};

const operateFormula = (operandsStack, operator) => {

	let operand2 = Number(operandsStack.pop());
	let operand1 = Number(operandsStack.pop());

	let val = null;
	switch (operator) {
		case '+': val = operand1 + operand2; break;
		case '-': val = operand1 - operand2; break;
		case '*': val = operand1 * operand2; break;
		case '/': if (operand2 > 0) val = operand1 / operand2; break;
		default:
	}

	if (val == null) {
		//console.error("Division by zero");
	}
	return val || 0;
};

const makeFlatArrayFromNestedArrays = (inputArray) => {
	let outputArray = [];
	inputArray.forEach(x => {
		if (Array.isArray(x)) {
			outputArray = [...outputArray, ...x];
		} else {
			outputArray = [...outputArray, x];
		}
	});
	return outputArray;
}


const makeAllFieldsInOneList = () => {
	let fieldsMergedRegisterSections = [
		schemaJsonMetamodel.register,
		...schemaJsonMetamodel.sections
	];

	// put in each field the section i.e. register name as tab name
	// this will be used for selected tab in order to send only this information
	// go two level, no recursion is needed:

	fieldsMergedRegisterSections.forEach(x => x.fields.forEach(b => {
		   b.tabname = x.display;
		   
		   if (Array.isArray(b))
		       b.forEach(c => {
				   c.tabname = b.tabname;

				   for (let element in c) {
					    let field = c[element];
						if (typeof field === "object") {
						  c[element].tabname = c.tabname;
						  for (let subelement in field) {
							if (typeof field[subelement] === "object") {
								field[subelement].tabname = c.tabname; 
							}							 		
						  }
						}
						
				   }
			   });

	}))


	let fieldsWithoutKeyFields = fieldsMergedRegisterSections.map(
		x => x.fields
	)



	let allFieldsInOneArray = makeFlatArrayFromNestedArrays(
		fieldsWithoutKeyFields
	);
	allFieldsInOneArray = makeFlatArrayFromNestedArrays(
		allFieldsInOneArray
	);
	allFieldsInOneArray = makeFlatArrayFromNestedArrays(
		allFieldsInOneArray
	);
	return allFieldsInOneArray;
}

const tranformFieldIntoFieldsWithReferences = () => {
	let allFieldsInOneArray = makeAllFieldsInOneList();
	let onlyCalcualtedFields = allFieldsInOneArray.filter(
		x =>
			x.type === possibleFieldTypes.CALCULATED ||
			x.type === possibleFieldTypes.CALCULATED_LATER
	);
	/*let onlyNotCalculatedFields = allFieldsInOneArray.filter(
		x =>
			!(
				x.type === possibleFieldTypes.CALCULATED ||
				x.type === possibleFieldTypes.CALCULATED_LATER
			)
	);*/

	const arrayToObject = (array, keyField) =>
		array.reduce((obj, item) => {
			obj[item[keyField]] = item;
			return obj;
		}, {});
	let allFieldsObjectMetamodel = arrayToObject(
		allFieldsInOneArray,
		"name"
	);

	allFieldsInOneArray.forEach(notCalculatedField => {
		allFieldsObjectMetamodel[notCalculatedField.name].references = [];
		onlyCalcualtedFields.forEach(calculatedField => {
			if (calculatedField.calculation)	 {
				if (calculatedField.calculation.type === "formula") {
					calculatedField.calculation.formula
						.filter(x => x.type === "operand")
						.forEach(refField => {
							if (notCalculatedField.name === refField.field) {
								allFieldsObjectMetamodel[
									notCalculatedField.name
								].references.push(calculatedField.name);
							}
						});
				}
				if (calculatedField.calculation.type === "sum") {
					calculatedField.calculation.fields.forEach(refField => {
						if (notCalculatedField.name === refField) {
							allFieldsObjectMetamodel[
								notCalculatedField.name
							].references.push(calculatedField.name);
						}
					});
				}
				if (calculatedField.calculation.type === "substring") {
					if(notCalculatedField.name === calculatedField.calculation.source) {
						allFieldsObjectMetamodel[notCalculatedField.name].references.push(calculatedField.name);					
					}
				}
			}
		});
	});

	return allFieldsObjectMetamodel;

}

let allFieldsWithReferences = tranformFieldIntoFieldsWithReferences();

const dynamicSurveyReducer = (
	state = { selectedYear: null, surveyData: { mappedFields: {} }, error: null, message: null, hasErrorMessage: false, hasInfoMessage: false, hideForm: false },
	action
) => {

	switch (action.type) {
		case SURVEY_YEAR_CHANGED:
			return {
				...state,
				selectedYear: action.selectedYear
			};
		case SURVEY_GET_PERIODS_STARTED:
			return {
				...state
			};
		case NO_DATA_ACTION:
			return {
				...state,
				message: "No Data Found for this Establishment. Please, change the Year - لم يتم العثور على بيانات لهذه المؤسسة. من فضلك ، تغيير السنة",
				showMessage: true,
				negativeMessage: true,
				hasInfoMessage: true,
				hideForm: true
			}
		case SURVEY_GET_PERIODS_SUCCESS:
			return {
				...state,
				years: action.periods.years,
				selectedYear: action.periods.years[0].year
			};
		case SURVEY_GET_PERIODS_FAILED:
			return {
				...state,
				error: action.error
			};
		case SURVEY_DATA_RECEIVED:
			let mappedFields = {};
			if (action.data && action.data.fields) {
				action.data.fields.forEach(x => {
					mappedFields[x.name] = x.value;
				});
			}

			let recalculatedValues = {...mappedFields};
			for(let propKey in allFieldsWithReferences) {
				recalculatedValues = recalculateReferences(allFieldsWithReferences, propKey, recalculatedValues);
			}

			return {
				...state,
				surveyData: { ...action.data, mappedFields: recalculatedValues},
				hideForm: false
			};
		case SURVEY_DATA_UDPATE:
			return {
				...state,
				surveyData: { ...state.surveyData, mappedFields: recalculateReferences(allFieldsWithReferences, action.name, action.data) }
			};
		case SEND_DATA_ERROR: {
			return {
				...state,
				error: action.error,
				hasErrorMessage: true
			}
		}
		case INFO_MESSAGE: {
			return {
				...state,
				message: action.message,
				hasInfoMessage: true
			}
		}
		case CLEAR_INFOR_AND_ERRO_MESSAGES: {
			return {
				...state,
				hasErrorMessage: false,
				hasInfoMessage: false,
				message: null,
				error: null
			}
		}
		default:
			return state;
	}
};

export default dynamicSurveyReducer;

export { allFieldsWithReferences };



// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/DynamicSurveyReducer.js